/** Default look of DSkhema diagrams; styles in the source override it per node or link. */
export const THEME = {
  font: 14,
  smallFont: 12,
  node: { fill: '#ffffff', stroke: '#334155', text: '#0f172a', width: 1.5 },
  decision: { fill: '#fef3c7', stroke: '#b45309' },
  terminal: { fill: '#e0e7ff', stroke: '#4338ca' },
  storage: { fill: '#dcfce7', stroke: '#15803d' },
  edge: { color: '#475569', width: 1.5, label: '#334155' },
  group: { fill: '#f8fafc', stroke: '#cbd5e1', title: '#475569' },
  participant: { fill: '#f1f5f9', stroke: '#334155' },
  activation: { fill: '#e0e7ff', stroke: '#4338ca' },
  note: { fill: '#fef9c3', stroke: '#ca8a04', text: '#713f12' },
  frame: { stroke: '#94a3b8', tag: '#e2e8f0', text: '#334155' },
  lifeline: '#94a3b8',
} as const;
